export function getClosestScrollContainer(el) {
  let parent = el.parentElement;

  while (parent) {
    const style = getComputedStyle(parent);

    const overflowY = style.overflowY;
    const overflowX = style.overflowX;

    const isScrollableY =
      (overflowY === "auto" || overflowY === "scroll") &&
      parent.scrollHeight > parent.clientHeight;

    const isScrollableX =
      (overflowX === "auto" || overflowX === "scroll") &&
      parent.scrollWidth > parent.clientWidth;

    if (isScrollableY || isScrollableX) {
      return parent;
    }

    parent = parent.parentElement;
  }

  // Fallback: the page itself
  return document.scrollingElement || document.documentElement;
}

export function isNearViewport(el, { container = null, threshold = 0 } = {}) {
  const elRect = el.getBoundingClientRect();

  const scrollContainer = container || getClosestScrollContainer(el)
  const containerRect = scrollContainer.getBoundingClientRect();

  // element position relative to the container's viewport
  const elTop = elRect.top - containerRect.top;
  const elBottom = elRect.bottom - containerRect.top;

  const containerHeight = scrollContainer.clientHeight;

  // true if any part of element is within [ -threshold ... containerHeight+threshold ]
  return (
    elBottom >= -threshold &&
    elTop <= containerHeight + threshold
  );
}

